import {
  MutateFunction,
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";
import { FirstParameter, SecondParameter } from "@/openapi/types";
import type request from "@/openapi/request";
import {
  postGetClassList,
  postGetClassMsg,
  postReachMsg,
} from "@/openapi/baob/pc.MsgManager";

export const usePCMsgManagerControllerPostGetClassMsg = (options: {
  query?: Partial<
    UseQueryOptions<
      ReturnType<typeof postGetClassMsg>,
      Error,
      Awaited<ReturnType<typeof postGetClassMsg>>
    >
  >;
  params: FirstParameter<typeof postGetClassMsg>;
  request?: SecondParameter<typeof request>;
}) => {
  return useQuery({
    queryKey: [`/baob/pc.MsgManager/getClassMsg`, options.params],
    queryFn: () => postGetClassMsg(options.params, options?.request),
    ...options?.query,
  });
};

export const usePCMsgManagerControllerPostGetClassList = (options: {
  query?: Partial<
    UseQueryOptions<
      ReturnType<typeof postGetClassList>,
      Error,
      Awaited<ReturnType<typeof postGetClassList>>
    >
  >;
  params: FirstParameter<typeof postGetClassList>;
  request?: SecondParameter<typeof request>;
}) => {
  return useQuery({
    queryKey: [`/baob/pc.MsgManager/getClassList`, options.params],
    queryFn: () => postGetClassList(options.params, options?.request),
    ...options?.query,
  });
};

export const usePCMsgManagerControllerPostReachMsg = (options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postReachMsg>>,
    Error,
    FirstParameter<typeof postReachMsg>
  >;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationFn: MutateFunction<
    Awaited<ReturnType<typeof postReachMsg>>,
    Error,
    FirstParameter<typeof postReachMsg>
  > = (params: FirstParameter<typeof postReachMsg>) => {
    return postReachMsg(params, options?.request);
  };

  return useMutation({ mutationFn, ...options?.mutation });
};
